<template>
  <div class="main">
    <Header />
    <div class="content-wrapper">
      <div class="content">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Sider from "./Sider";
import Header from "./Header";
import Footer from "./Footer";
import { mapGetters } from "vuex";

export default {
  name: "Layout",
  components: {
    Sider,
    Header,
    Footer,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    ...mapGetters(["menu"]),
    highLightItem() {
      const currentRoute = this.$route.name;
      if (this.breadList.length > 2) {
        const { route = null } = this.breadList[1];
        return (route && route.name) || currentRoute;
      }
      return currentRoute;
    },
    breadList() {
      return (this.$route.meta && this.$route.meta.breadcrumb) || [];
    },
  },
  methods: {
    breadCrumbDisplay(source) {
      if (typeof source === "function") {
        return source(this.$route.params);
      }
      return source;
    },
  },
};
</script>
<style scoped lang="scss">
.main {
  width: 100%;
  .content-wrapper {
    width: 100%;
    background-color: rgb(226, 226, 226);
    .content {
      max-width: 1440px;
      margin: 0 auto;
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  .content {
    padding: 0 15px;
  }
}
</style>
